import React, { useCallback, useEffect, useState } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { useDispatch } from 'react-redux';
import {
  getAcademicCalendar,
  getLeadMinDetails,
  getRescheduledCalendars,
  getSubjectEnrollmentIds,
} from '../../redux/features/CRDslice';
import { useSelector } from 'react-redux';
import { Autocomplete, Box, Button, Grid, Paper, TextField, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { motion } from 'framer-motion';
import Loader3D from '../../components/Loader/Loader3D';
import NoDataFound from '../../components/NodataIndication/NoDataFound';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import CustomGridToolbar from '../../components/datagrid/GridToolBar';
import { DataGrid } from '@mui/x-data-grid';
import { academicCalendarTableHeader } from '../../components/datagrid/academicCalendar/academicCalendarTableHeader';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useLocation } from 'react-router-dom';
import LeadDetails from './LeadDetails';
import MarkAttendanceModalContent from './MarkAttendanceModalContent';

const AcademicCalendarView = ({ publicRoute }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { academicCalendar, loading, rescheduledCalendars, subjectEnrollmentIds, leadDetails } = useSelector(
    (state) => state.crd,
  );
  const [open, setOpen] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false); //SETTING STATE TO AVOID UNWANTED ANIMATION WHILE RENDERING
  const [gridSize, setGridSize] = useState(10);
  const pathParts = location.pathname.split('/');
  const subjectEnrollmentID = pathParts[4] || null;
  const tutorID = pathParts[5] || null;

  const queryParams = new URLSearchParams(location.search);
  const leadIdFromQuery = queryParams.get('leadId');
  const [seletctedSubEnrollmentId, setseletctedSubEnrollmentId] = useState();
  const [globalModalOpen, setGlobalModalOpen] = useState(false);
  const [selectedModalContent, setSelectedModalContent] = useState();
  const [selectedItem, setSelectedItem] = useState();
  useEffect(() => {
    if (!publicRoute) {
      // CALL FOR SUBJECT ENROLMENT IDS AGAINST LEAD ID
      dispatch(getSubjectEnrollmentIds(leadIdFromQuery));
    } else if (publicRoute) {
      //IF PUBLIC ROUTE IT WILL CALL THE CALENDAR WRT TO THE PARAMS GETTING FROM THE OLD PORTAL
      dispatch(
        getAcademicCalendar({
          subject_enrollment_id: subjectEnrollmentID,
          tutorID: tutorID,
        }),
      );
    }
  }, [leadIdFromQuery, publicRoute]);

  useEffect(() => {
    if (subjectEnrollmentIds.length && !seletctedSubEnrollmentId) {
      setseletctedSubEnrollmentId(subjectEnrollmentIds[0].subject_enrollment_id);
    }
    if (seletctedSubEnrollmentId) {
      dispatch(
        getAcademicCalendar({
          subject_enrollment_id: seletctedSubEnrollmentId,
          tutorID: null,
        }),
      );
    }
  }, [seletctedSubEnrollmentId, subjectEnrollmentIds]);

  useEffect(() => {
    if (publicRoute) {
      dispatch(getLeadMinDetails(subjectEnrollmentID));
    } else if (!publicRoute && seletctedSubEnrollmentId) {
      //api call only after the subjectenrollmentId is set
      dispatch(getLeadMinDetails(seletctedSubEnrollmentId));
    }

    //CALL FOR LEAD NAME AND GET DETAILS
  }, [subjectEnrollmentID, seletctedSubEnrollmentId]);

  const boxClickFunction = useCallback((item) => {
    //CALLBACK FUNCTION TO OPEN DIALOG BOX IT ONLY OPEN THE DIALOG BOX IF THE SESSION IS RESCHEDULED AND IT WILL CALL API FOR TO LOG RESCHEDULED SESSIONS DETAILAS
    if (item.rescheduled_id) {
      setOpen(true);
      dispatch(getRescheduledCalendars(item.session_schedule_id));
    }
  }, []);

  const boxCloseFuntion = () => {
    setOpen(false);
  };
  const handleEnrolmentIdChange = (event, option) => {
    setseletctedSubEnrollmentId(option.subject_enrollment_id);
  };

  const attendanceMarkModalFunction = (item) => {
    setSelectedModalContent('Mark Attendance');
    setSelectedItem(item);
    setGlobalModalOpen(true);
  };

  const handleGlobalDialogClose = () => {
    setSelectedModalContent(null);
    setSelectedItem(null);
    setGlobalModalOpen(false);
  };
  const BoxDesign = React.memo(({ item }) => {
    const backgroundColor =
      !item.trainerAttendanceID && item.rescheduled_id //NO TRAINER ID AND PRESENCE OF RESCHEDULED ID MEANS THE OBJECT IS RESCHEDULED SO MAKE THE COLOR TO YELLOW
        ? '#fce9034a'
        : item.trainerAttendanceID // IF TRAINER ID IS PRESENT THEN MAKE THE COLOR TO GREEN ELSE BLUE
          ? '#41fc032e'
          : item.reschedule_requested_by == 1 && !item.rescheduled_at
            ? '#ff00004d'
            : '#03a9fc2e';
    return (
      <motion.div
        key={item.id} // Ensures animation runs only once per unique item
        initial={!hasAnimated ? { rotateY: 180 } : false} // Only animate initially
        animate={!hasAnimated ? { rotateY: 0 } : false} // Stop animation after first render
        transition={{ duration: 0.5 }}
        style={{ perspective: '1000px' }}
        onAnimationComplete={() => setHasAnimated(true)} // Set flag after first animation
      >
        <Paper
          onClick={() => boxClickFunction(item)}
          elevation={3}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: backgroundColor,
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '130px',
            transition: 'transform 0.3s ease, border 0.3s ease',
            '&:hover': {
              border: item.rescheduled_id ? '0.5px solid black' : '',
              transform: item.rescheduled_id ? 'scale(1.05)' : '',
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100px',
              height: '30px',
              bgcolor:
                !item.trainerAttendanceID && item.rescheduled_id //SIDE BANNER COLOR MAKING TO DARK TO SHOW COMPLETED, PENDING, RESCHEDULED
                  ? '#fce903' //YELLOW RESCHEDULED
                  : item.trainerAttendanceID
                    ? '#41fc0378' //GREEN DONE
                    : item.reschedule_requested_by == 1 && !item.rescheduled_at
                      ? 'RED'
                      : '#03a9fc75', //PENDING BLUE
              color: 'white',
              fontSize: '8px',
              fontWeight: 'bold',
              textAlign: 'center',
              transform: 'rotate(-45deg) translate(-20px, -10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingRight: '7px',
            }}
          >
            {!item.trainerAttendanceID && item.rescheduled_id
              ? 'RESCHEDULED'
              : item.trainerAttendanceID
                ? 'COMPLETED'
                : item.reschedule_requested_by == 1 && !item.rescheduled_at
                  ? 'RESCHEDULE REQUESTED'
                  : 'PENDING'}
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              cursor: 'pointer',
            }}
          >
            {/* MARK ATTENDANCE BUTTON SECTION */}
            {!item.trainerAttendanceID && !publicRoute && (
              <Box
                sx={{
                  borderRadius: '50%',
                  px: 0.5,
                  pt: 0.5,
                  border: '1px solid transparent',
                  '&:hover': {
                    border: '1px solid black',
                  },
                }}
                onClick={() => attendanceMarkModalFunction(item)}
              >
                <Tooltip title="Mark Attendance">
                  <Icon icon="mdi:checkbox-marked-circle-plus-outline" width="20" height="20" />
                </Tooltip>
              </Box>
            )}

            {item.academic_calendar_data?.session_no && ( //TOOLTIP TO SHOW THE SESSION DETAILS ON HOVER,DATA IS AVAILBALE ONLY FOR COMPLETED SESSIONS
              <Tooltip
                title={
                  <Box
                    sx={{
                      bgcolor: 'white',
                      color: 'black',
                      p: 1,
                      borderRadius: '4px',
                      boxShadow: 3,
                      minWidth: '120px',
                    }}
                  >
                    <Typography variant="body2">
                      <strong>Chapter : </strong>
                      {item.academic_calendar_data?.chapter}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Topic : </strong>
                      {item.academic_calendar_data?.topic}
                    </Typography>
                    <Typography variant="body2">
                      <strong> Objectives : </strong>
                      {item.academic_calendar_data?.objectives}
                    </Typography>
                  </Box>
                }
                arrow
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  <Icon icon="mdi:eye" width="20" height="20" />
                </Box>
              </Tooltip>
            )}
          </Box>

          <Typography mt={1} fontWeight="bold" color="primary">
            {dayjs(item.session_date).format('YYYY ddd, MMM D')}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {dayjs(item.from_time, 'HH:mm:ss').format('hh:mm A')} - {dayjs(item.to_time, 'HH:mm:ss').format('hh:mm A')}
          </Typography>

          <Typography variant="button" color="textSecondary">
            Session {item.session_no}
          </Typography>
          {item?.type && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Typography
                variant="caption"
                color={item?.type?.toLowerCase().includes('exam') ? '#df4d51' : '#63738c'}
                sx={{
                  fontStyle: 'italic',
                  fontWeight: 'bold',
                  // textShadow: '0.5px 0.5px 0 black'
                }}
              >
                {item?.type || 'Class'}
              </Typography>
            </Box>
          )}
        </Paper>
      </motion.div>
    );
  });

  return (
    <GlobalWrapper title="Academic Calendar">
      <Box>
        {loading ? (
          <Box>
            <Loader3D />
          </Box>
        ) : (
          <Box>
            {!publicRoute && (
              <Box display="flex" justifyContent={'space-between'} gap={2} alignItems={'center'}>
                <Box mb={1} width="100%">
                  <Autocomplete
                    fullWidth
                    disabled={loading}
                    name="subject"
                    id="subject"
                    options={Array.isArray(subjectEnrollmentIds) ? subjectEnrollmentIds : []}
                    getOptionLabel={(sub) => sub?.subject_name?.concat(' (', sub.course_name, ')') || ''}
                    value={
                      (subjectEnrollmentIds.length &&
                        subjectEnrollmentIds?.find((sub) => sub?.subject_enrollment_id == seletctedSubEnrollmentId)) ||
                      null
                    }
                    onChange={handleEnrolmentIdChange}
                    renderInput={(params) => (
                      <TextField disabled fullWidth autoComplete="off" {...params} label="Subjects" />
                    )}
                  />
                </Box>
              </Box>
            )}
            <Box mb={1}>
              <LeadDetails leadDetails={leadDetails} seletctedSubEnrollmentId={seletctedSubEnrollmentId} />
            </Box>
            {academicCalendar.length == 0 ? (
              <Box mt={10}>
                <NoDataFound />
              </Box>
            ) : (
              <Paper elevation={6} sx={{ p: 2, borderRadius: 2 }}>
                <Grid container spacing={2}>
                  {academicCalendar.length &&
                    academicCalendar.map((item) => (
                      <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                        <BoxDesign item={item} />
                      </Grid>
                    ))}
                </Grid>
              </Paper>
            )}
          </Box>
        )}
      </Box>
      <GlobalDialog
        open={open}
        setOpen={setOpen}
        maxWidth={'lg'}
        fullWidth
        title={'Rescheduled Details'}
        closeButton={true}
        closeCondition={boxCloseFuntion}
        content={
          <>
            <Box>
              <DataGrid
                components={{ Toolbar: CustomGridToolbar }}
                rows={rescheduledCalendars}
                columns={academicCalendarTableHeader}
                loading={loading}
                getRowId={(row) => row.session_schedule_id}
                pageSize={gridSize}
                autoHeight
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
              />
            </Box>
          </>
        }
      />

      <GlobalDialog
        open={globalModalOpen}
        setOpen={setGlobalModalOpen}
        maxWidth={'sm'}
        fullWidth
        title={selectedModalContent ? selectedModalContent : ''}
        closeButton={true}
        closeCondition={handleGlobalDialogClose}
        content={
          <>
            <Box>
              {selectedModalContent === 'Mark Attendance' && (
                <MarkAttendanceModalContent
                open={globalModalOpen}
                setOpen={setGlobalModalOpen}
                  row={selectedItem}
                  apiCall={getAcademicCalendar}
                  dispatchParams={
                    publicRoute
                      ? {
                          subject_enrollment_id: subjectEnrollmentID,
                          tutorID: tutorID,
                        }
                      : {
                          subject_enrollment_id: seletctedSubEnrollmentId,
                          tutorID: null,
                        }
                  }
                />
              )}
            </Box>
          </>
        }
      />
    </GlobalWrapper>
  );
};

export default AcademicCalendarView;
